module.exports = __webpack_public_path__ + "static/media/backArrow.7a852741.svg";